import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { axiosInstance } from "../client";
import { MIME_TYPE_MERGE_PATCH_JSON } from "../../constants/mimeTypes";
import {
  FormConfiguration,
  FormConfigurationTheme,
} from "@rumble-it/common-lib/types/models/FormConfiguration.interface";
import { PaginationParams } from "@rumble-it/common-lib/types/api/PaginationParams.interface";

export interface FormConfigurationsQueryParams extends PaginationParams {}

export const fetchFormConfigurations = async (
  params: FormConfigurationsQueryParams,
): Promise<CollectionResponse<FormConfiguration>> =>
  axiosInstance
    .get(`/admin/form-configurations`, { params })
    .then((response) => response.data);

export const fetchFormConfigurationsById = async (
  id: string,
): Promise<FormConfiguration> =>
  axiosInstance.get(`/admin/form-configurations/${id}`).then((response) => {
    response.data.configuration = JSON.parse(response.data.configuration);
    return response.data;
  });

export const updateFormConfigurationById = async (
  id: string,
  data: any,
): Promise<null> =>
  axiosInstance
    .patch(`/admin/form-configurations/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

export const fetchFormConfigurationThemeById = async (
  id: string,
): Promise<FormConfigurationTheme> =>
  axiosInstance.get(`/admin/themes/${id}`).then((response) => {
    response.data.configuration = JSON.parse(response.data.configuration);
    return response.data;
  });

export const updateFormConfigurationThemeById = async (
  id: string,
  data: any,
): Promise<null> =>
  axiosInstance
    .patch(`/admin/themes/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);
